import { Formula, FormulaCards, Measures, PhysicalForms, SearchFormula } from '../../interfaces/formula';
import { workspace } from '../../shared/api';

export const FormulaService = {
  async fetchFormulas(prescriptionId: number, page?: number, pageSize?: number): Promise<FormulaCards> {
    const { data } = await workspace.get(
      `prescription-compounded-formula/prescription/${prescriptionId}/item?page=${page}&pageSize=${pageSize}`
    );
    return data;
  },

  async createFormula(prescriptionId: number, doctorId: number, formula: Formula): Promise<Formula> {
    const { data } = await workspace.post(
      `prescription-compounded-formula/prescription/${prescriptionId}/item/${doctorId}`,
      formula
    );
    return data;
  },

  async searchFormula(doctorId: number, query?: string, page?: number, pageSize?: number): Promise<SearchFormula> {
    const params = new URLSearchParams();
    if (query) {
      params.append('query', query);
    }
    if (page) {
      params.append('page', page.toString());
    }
    if (pageSize) {
      params.append('pageSize', pageSize.toString());
    }
    const queryString = params.toString();
    const url = `prescription-compounded-formula/prescriber/${doctorId}/search${queryString ? `?${queryString}` : ''}`;
    const { data } = await workspace.get(url);
    return data;
  },

  async getFormulaById(prescriptionId: number, formulaId: number): Promise<Formula> {
    const { data } = await workspace.get(
      `prescription-compounded-formula/prescription/${prescriptionId}/item/${formulaId}`
    );
    return data;
  },

  async getDoctorFormulaById(doctorId: number, formulaId: number): Promise<Formula> {
    const { data } = await workspace.get(
      `prescription-compounded-formula/prescriber/${doctorId}/${formulaId}`
    );
    return data;
  },

  async updateFormula(prescriptionId: number, doctorId: number, formulaId: number, formula: Formula): Promise<Formula> {
    const { data } = await workspace.patch(
      `prescription-compounded-formula/prescription/${prescriptionId}/item/${formulaId}/${doctorId}`,
      { ...formula }
    );
    return data;
  },

  async deleteFormula(doctorId: number, formulaId: number): Promise<void> {
    await workspace.delete(`/prescription-compounded-formula/prescriber/${doctorId}/${formulaId}`);
  },

  async deleteFormulaFromPrescription(prescriptionId: number, formulaId: number): Promise<void> {
    await workspace.delete(`/prescription-compounded-formula/prescription/${prescriptionId}/item/${formulaId}`);
  },

  async getPhysicalForms(page?: number, pageSize?: number, query?: string): Promise<PhysicalForms> {
    const params = new URLSearchParams();
    if (page && pageSize) {
      params.append('page', page.toString());
      params.append('pageSize', pageSize.toString());
    }
    if (query) {
      params.append('query', query);
    }
    const queryString = params.toString();
    const { data } = await workspace.get(
      `/prescription-compounded-formula/physical-forms/search${queryString ? `?${queryString}` : ''}`
    );
    return data;
  },

  async getMeasures(page?: number, pageSize?: number): Promise<Measures> {
    const params = page && pageSize ? `?page=${page}&pageSize=${pageSize}` : '';
    const { data } = await workspace.get(`/prescription-compounded-formula/measures${params}`);
    return data;
  },

  async addFormulaToPrescription(prescriptionId: number, doctorId: number, formulaId: number): Promise<Formula> {
    const { data } = await workspace.post(
      `prescription-compounded-formula/prescription/${prescriptionId}/item/${doctorId}/formula/${formulaId}`
    );
    return data;
  },
};
